import url from './url';
import locale from './locale';
import modules from './modules';
import sysRole from './role';
import company from './company';
import functions from './functions';

export default {
  url,
  locale,
  modules,
  sysRole,
  company,
  functions,
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/configs/index.js
 **/